import FormVendedor from "components/FormVendedor";

const CriarVendedor = () => (
  <div className="card">
    <FormVendedor />
  </div>
);

export default CriarVendedor;
